<template>
  <div class="full bg-blue-100">
    <div v-if="!API.Token.JWT">
      <div class="p-3 text-4xl">Welcome to our...</div>
      <div class="p-3 text-xl pt-0"> Brand new paper analysis system!</div>
      <div class="p-3 text-xl"> To begin, please sign in with our PALMS Team Login ID.</div>
    </div>
    <div v-if="API.Token.JWT">
      <div class="p-3 text-4xl">Welcome back! @{{ API.Token.Profile.username }}</div>
      <div class="p-3 text-xl"> To begin, click the Dashboard button.</div>
    </div>
  </div>
</template>

<script>
import * as API from '../pdfAPI'
export default {
  data () {
    return {
      API
    }
  }
}
</script>

<style>

</style>
